import React from "react";

function Eraser({
	hasBackground,
	isErasing,
	setIsErasing,
	eraserSize,
	setEraserSize,
	onUndoLastErase,
	onClearAllErases,
}) {
	return (
		<div className="flex flex-col items-start gap-4">
			{/* Row 1: Layer Up, Layer Down, Download */}
			<div className="flex flex-row gap-2">
				{/* Row 4: Erase Tools */}
				<div className="flex flex-col gap-2">
					{/* Row for text + toggle */}
					<div className="flex items-center gap-2">
						<span className="text-monadWhite text-sm md:text-base">
							{isErasing ? "Stop Erasing" : "Enable Erasing"}
						</span>

						{/* Toggler */}
						<label
							className={`
        relative inline-flex items-center
        ${hasBackground ? "cursor-pointer" : "cursor-not-allowed opacity-60"}
      `}
						>
							<input
								type="checkbox"
								className="sr-only peer"
								checked={isErasing}
								onChange={() => setIsErasing((prev) => !prev)}
								disabled={!hasBackground}
							/>
							<div
								className="
          w-8 h-4 md:w-11 md:h-6 bg-gray-200 peer-focus:outline-none
          rounded-full peer dark:bg-gray-700
          peer-checked:after:translate-x-full
          peer-checked:after:border-white
          after:content-[''] after:absolute after:top-[2px] after:left-[2px]
          after:bg-white after:border-gray-300 after:border
          after:rounded-full after:h-4 md:after:h-5 after:w-4 md:after:w-5
          after:transition-all peer-checked:bg-monadAccent
        "
							/>
						</label>
					</div>

					{/* Show eraser tools only when erasing is enabled */}
					{isErasing && (
						<>
							<button
								onClick={onUndoLastErase}
								className="
          px-3 py-1 rounded bg-monadAccent text-monadWhite
          hover:bg-monadAccentDark text-sm md:text-base transition-colors
        "
							>
								Remove Last Erase
							</button>
							<button
								onClick={onClearAllErases}
								className="
          px-3 py-1 rounded bg-monadAccent text-white 
          hover:bg-monadAccentDark text-sm md:text-base transition-colors
        "
							>
								Remove All Erases
							</button>

							{/* Eraser Size Slider */}
							<div className="flex flex-col items-start gap-1">
								<label className="text-monadWhite">Eraser Size: {eraserSize}</label>
								<input
									type="range"
									min={5}
									max={100}
									value={eraserSize}
									onChange={(e) => setEraserSize(parseInt(e.target.value))}
								/>
							</div>

							{/* Preview Circle */}
							<div className="flex flex-col items-start gap-1 mt-1">
								<label className="text-monadWhite">Preview:</label>
								<svg width="100" height="100" className="border border-monadGray">
									<circle cx="50" cy="50" r={eraserSize / 2} fill="#836EF9" />
								</svg>
							</div>
						</>
					)}
				</div>
			</div>
		</div>
	);
}

export default Eraser;
